import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Layout from "../../component/layout";
import { TabView, TabPanel } from 'primereact/tabview';
import AccountsDashboard from './components/AccountsDashboard';
import BalanceSheet from './components/BalanceSheet';
import ProfitLoss from './components/ProfitLoss';
import TrialBalance from './components/TrialBalance';
import LedgerStatement from './components/LedgerStatement';
import ManageAccounts from './components/manageAccounts/ManageAccounts';

const Accounts = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={""}>Accounts</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <h5>Accounts Management</h5>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="card-body py-0">
                                            <ul
                                                className="nav nav-tabs profile-tabs"
                                                id="myTab"
                                                role="tablist"
                                            >
                                                <li className="nav-item">
                                                    <a
                                                        className={`nav-link ${activeIndex === 0 ? 'active' : ''}`}
                                                        id="accounts-tab"
                                                        data-bs-toggle="tab"
                                                        href="#accounts-section"
                                                        role="tab"
                                                        aria-selected={activeIndex === 0}
                                                        onClick={() => setActiveIndex(0)}
                                                    >
                                                        <i className="ti ti-coin me-2"></i>
                                                        Accounts
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        className={`nav-link ${activeIndex === 1 ? 'active' : ''}`}
                                                        id="reports-tab"
                                                        data-bs-toggle="tab"
                                                        href="#reports-section"
                                                        role="tab"
                                                        aria-selected={activeIndex === 1}
                                                        onClick={() => setActiveIndex(1)}
                                                    >
                                                        <i className="ti ti-report-money me-2"></i>
                                                        Reports
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="tab-content">
                                        {/* Accounts Section */}
                                        <div
                                            className={`tab-pane ${activeIndex === 0 ? 'show active' : ''}`}
                                            id="accounts-section"
                                            role="tabpanel"
                                        >
                                            <AccountsTabView />
                                        </div>

                                        {/* Reports Section */}
                                        <div
                                            className={`tab-pane ${activeIndex === 1 ? 'show active' : ''}`}
                                            id="reports-section"
                                            role="tabpanel"
                                        >
                                            <ReportsTabView />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

// Accounts Tab View Component
const AccountsTabView = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <div className="card">
                    <div className="card-body">
                        <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                            <TabPanel header="Dashboard">
                                <AccountsDashboard />
                            </TabPanel>
                            <TabPanel header="Chart of Accounts">
                                <ManageAccounts />
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Reports Tab View Component
const ReportsTabView = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <div className="card">
                    <div className="card-body">
                        <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                            <TabPanel header="Balance Sheet">
                                <BalanceSheet />
                            </TabPanel>
                            <TabPanel header="Profit & Loss">
                                <ProfitLoss />
                            </TabPanel>
                            <TabPanel header="Trial Balance">
                                <TrialBalance />
                            </TabPanel>
                            <TabPanel header="Ledger Statement">
                                <LedgerStatement />
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Accounts;